<template>
    <div>
        <div class="panel panel-info">
            <div class="panel-heading">
                <i class="fa fa-table" aria-hidden="true"></i> USUÁRIOS DO CLIENTE
            </div>
            <div class="panel-body">

                <table id="mytable" class="table table-bordred table-striped">

                    <thead>
                    <tr>
                        <th>NOME</th>
                        <th style="text-align: center;">USUÁRIO</th>
                        <th style="text-align: center;">AÇÕES</th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr v-for="r in contratos" v-bind:key="r._id">
                        <td>{{ r.nome }}</td>
                        <td style="text-align: center">{{ r.usuario || r.email }}</td>
                        <td style="text-align: center">
                            <a :href="'#/contrato/usuario/' + id + '/' + r._id" class="btn btn-primary btn-xs">
                                ABRIR <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                            </a>
                        </td>
                    </tr>
                    </tbody>

                </table>

            </div>
        </div>
    </div>
</template>
<script>
import { Usuario } from "../../class/usuario";

export default {
    props: {
        id: {
            default: null
        }
    },
    data() {
        return {
            contratos: [],
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    },
    mounted() {
        this.loadComandos();
    },
    methods: {
        async loadComandos() {
            this.contratos = await Usuario.byContrato(this.id);
        }
    }
};
</script>
